import { BridgeComponent, BridgeElement } from "@hotwired/hotwire-native-bridge"

// MenuComponent - Adds a native nav bar menu (⋯) whose entries mirror hidden
// item elements in the DOM.
//
// The container element carries the menu's own bridge attributes:
//   data-bridge-ios-image  SF Symbol for the menu button (e.g. "ellipsis")
//   data-bridge-side       "left" or "right" (default: "right")
//
// Each item target carries its own bridge attributes:
//   data-bridge-title      menu entry label
//   data-bridge-ios-image  SF Symbol for the entry
//   data-bridge-action     "share" for a native share entry, otherwise omitted
//   data-bridge-url        share URL (used when action is "share")
//
// The native side replies to "connect" with `{ index }` when a non-share entry
// is tapped; we click the matching item element. Entries with action "share"
// are handled entirely natively (share sheet) and never reply.
export default class extends BridgeComponent {
  static component = "menu"
  static targets = ["item"]

  connect() {
    super.connect()

    const element = this.bridgeElement
    const image = element.bridgeAttribute("ios-image")
    const side = element.bridgeAttribute("side") || "right"

    const items = this.itemTargets.map((item, index) => {
      const bridgeItem = new BridgeElement(item)

      return {
        index,
        title: bridgeItem.title,
        image: bridgeItem.bridgeAttribute("ios-image"),
        action: bridgeItem.bridgeAttribute("action"),
        url: bridgeItem.bridgeAttribute("url"),
      }
    })

    this.send("connect", { image, side, items }, (message) => {
      const item = this.itemTargets[message?.data?.index]

      if (item) {
        new BridgeElement(item).click()
      }
    })
  }
}
